import React from 'react';
import { LoginForm } from './loginForm';
import { RegisterForm } from './registerForm';

export const LoginRegisterWrapper = ({dispatch, countries, nationalities}) => {
  return (
    <div className='login-register-wrapper'>
      <LoginForm dispatch={dispatch} />
      <RegisterForm countries={countries} nationalities={nationalities} dispatch={dispatch} />
    </div>
  )

}